import React from "react";
import GaugeChart from "react-gauge-chart";
import { Modal, ModalHeader, ModalBody } from "reactstrap";
import { withRouter } from "react-router-dom";
import { withApollo } from "react-apollo";
import { connect } from "react-redux";
import { PDFDownloadLink } from "@react-pdf/renderer";

import Report from "./components/GenerateReport";
import CollapseComponent from "../Collapse";
import { GetSRASectionQuestions } from "../../queries/assessment";

class SRAReportModal extends React.Component {
  state = {
    questions: [],
    sectionQuestions: [],
    collapse: false,
    gaugeChartCanvas: null
  };

  async componentDidMount() {
    const sectionQuestions = [...this.state.sectionQuestions];
    const sectionsLength = this.props.sections.length - 1;
    const index = 0;
    this._isMounted = true;

    try {
      if (this._isMounted) {
        this.getSection(index, sectionsLength, sectionQuestions).then(
          answers => {
            this.setState(
              {
                sectionQuestions: answers
              },
              () => {
                // console.log(this.state.sectionQuestions);
              }
            );
          }
        );
      }
    } catch (err) {
      console.log(err);
    }
  }

  toggle = () => {};

  getSection = async (index, sectionsLength, sectionQuestions) => {
    let section = this.props.sections[index];
    let backendSectionName = section.backendSectionName;

    try {
      let {
        data: {
          getSRASectionQuestions: { questions }
        }
      } = await this.props.client.query({
        query: GetSRASectionQuestions(backendSectionName),
        fetchPolicy: "network-only",
        variables: {
          backendSectionName
        }
      });

      questions = JSON.parse(questions);
      // console.log(sectionQuestions)
      const sectionFound = sectionQuestions.find(
        question => question.backendSectionName === backendSectionName
      );

      if (sectionFound != null) {
        sectionQuestions[sectionQuestions.indexOf(sectionFound)] = {
          backendSectionName,
          questions
        };
      } else {
        sectionQuestions.push({ backendSectionName, questions });
      }

      if (index === sectionsLength) {
        return sectionQuestions;
      } else {
        index = index + 1;
        return this.getSection(index, sectionsLength, sectionQuestions);
      }
    } catch (err) {
      console.log(err);
    }
  };

  renderSections = () => {
    let sections = [];

    sections = this.props.sections.map((section, idx) => {
      // console.log(section);
      return (
        <div key={idx} className="report__progress">
          <CollapseComponent
            children={this.renderAnswers(section, idx + 1)}
            idx={idx}
            section={section.sectionName}
            risk={section.riskScore}
            progress={section.progress}
            title="Click here to expand"
            className="risk__table"
          ></CollapseComponent>
        </div>
      );
    });

    return sections;
  };

  renderAnswers = (section, idx) => {
    let fields = [];
    const sectionFound = this.state.sectionQuestions.find(
      questions => questions.backendSectionName === section.backendSectionName
    );

    // console.log(sectionFound);
    // console.log(this.state.sectionQuestions);
    // console.log(section);

    if (sectionFound !== undefined) {
      const questions = sectionFound.questions;

      Object.keys(questions).forEach((key, questionIndex) => {
        /[0-9]*[a-z]/.test(key)
          ? fields.push(
              questions[key].map((answer, i) => {
                // console.log(answer.selectedAnswer);
                if (answer.selectedAnswer != null) {
                  return (
                    <div key={`${key}${i}`} className="risk__table__body">
                      <div>{idx}</div>
                      <div>{answer.question}</div>
                      <div>
                        {`Likelihood: ${answer.selectedAnswer.likelihood}`}
                      </div>
                      <div>{`Impact: ${answer.selectedAnswer.impact}`}</div>
                      <div
                        className={
                          answer.selectedAnswer.riskScore === 0
                            ? ""
                            : answer.selectedAnswer.riskScore < 11
                            ? "green"
                            : answer.selectedAnswer.riskScore < 51
                            ? "yellow"
                            : answer.selectedAnswer.riskScore <= 100
                            ? "red"
                            : ""
                        }
                      >
                        {`Risk: ${
                          answer.selectedAnswer.likelihood === "NA" ||
                          answer.selectedAnswer.impact === "NA"
                            ? "NA"
                            : String(answer.selectedAnswer.risk)
                        }`}
                      </div>
                    </div>
                  );
                } else {
                  return null;
                }
              })
            )
          : questions[key].selectedAnswer != null &&
            fields.push(
              <div
                key={`${key}-${questionIndex}`}
                className="risk__table__body"
              >
                <div>{idx}</div>
                <div>{questions[key].question}</div>

                {this.getSelectedAnswer(questions[key].selectedAnswer, key)}

                {this.getEducation(
                  questions[key].selectedAnswer,
                  questions[key].answers,
                  sectionFound.sectionName,
                  questions[key].education,
                  key
                )}
                <div></div>
              </div>
            );
      });
    }
    return fields;
  };

  getSelectedAnswer = (selectedAnswer, key) => {
    if (selectedAnswer !== undefined && selectedAnswer.length > 1) {
      return (
        <div>
          {selectedAnswer.map((answer, i) => {
            return (
              <ul key={`${key}${i}`}>
                <li>{answer}</li>
              </ul>
            );
          })}
        </div>
      );
    } else {
      return <div>{selectedAnswer}</div>;
    }
  };

  getEducation = (selectedAnswer, answers, sectionName, education, key) => {
    if (typeof selectedAnswer === "object" && selectedAnswer.length === 1) {
      let answerFound = answers.find(
        (answer, idx) => answer === selectedAnswer[0]
      );

      if (answerFound !== undefined && education !== undefined) {
        let index = answers.indexOf(answerFound);

        if (key === "6" && sectionName === "sra:basic") {
          education = education.replace('"accepted"', "'accepted'");
        }
        return <div>{JSON.parse(education)[`${index + 1}`]}</div>;
      }
    }
    return "";
  };

  render() {
    return (
      <div>
        <Modal isOpen={true} toggle={this.props.toggle} className="risk__modal">
          <ModalHeader id="hipaa__sra" toggle={this.props.toggle}>
            HIPAA SECURITY RISK ASSESSMENT REPORT
          </ModalHeader>
          {this.state.sectionQuestions.length !== 0 ? (
            <React.Fragment>
              <ModalBody className="risk__modal__body" id="sra-report-modal">
                <PDFDownloadLink
                  className={`dashboard btn btn-primary`}
                  style={{ marginBottom: 0, marginTop: "10px", float: "right" }}
                  document={
                    <Report
                      title={`${this.props.tenant.companyName} - Posture HIPAA Security Risk Assessment Report`}
                      answers={this.state.sectionQuestions}
                      sections={this.props.sections}
                      userName={`${this.props.user["given_name"]} ${this.props.user["family_name"]}`}
                      overallRisk={this.props.overallRisk}
                    />
                  }
                  fileName="Posture HIPAA Security Risk Assessment Report.pdf"
                >
                  {({ blob, url, loading, error }) =>
                    loading ? "Loading document..." : "Download now"
                  }
                </PDFDownloadLink>
                <div id="gauge-chart-export" style={{ marginTop: "60px" }}>
                  <div className="risk__chart">
                    <span className="good__score">Low Risk</span>
                    <GaugeChart
                      id="gauge-chart2"
                      nrOfLevels={20}
                      percent={this.props.overallRisk.riskScore / 100}
                      hideText={true}
                    />
                    <span className="bad__score">High Risk</span>
                  </div>
                  <div className="risk__score">
                    <p>
                      Overall Risk Score: {this.props.overallRisk.riskScore} ||
                      {this.props.overallRisk.riskScore < 11
                        ? " Low"
                        : this.props.overallRisk.riskScore < 51
                        ? " Medium"
                        : " High"}{" "}
                      Risk
                    </p>
                    <p></p>
                  </div>
                </div>
                <div className="risk__tables">{this.renderSections()}</div>
              </ModalBody>
            </React.Fragment>
          ) : (
            <div className="custom_load load" style={{ height: "50vh" }}>
              <div className="load__icon-wrap">
                <svg className="load__icon">
                  <path
                    fill="#2d9aa6"
                    d="M12,4V2A10,10 0 0,0 2,12H4A8,8 0 0,1 12,4Z"
                  />
                </svg>
              </div>
            </div>
          )}
        </Modal>
      </div>
    );
  }
}

export default withRouter(
  withApollo(
    connect(state => {
      return {
        tenant: state.auth.tenant,
        user: state.auth.user
      };
    })(SRAReportModal)
  )
);



// WEBPACK FOOTER //
// ./src/components/sra/SRAReportModal.js